import React from 'react';
import Routes from './routes';
import 'rsuite/dist/rsuite.min.css';
import GlobalStyle from './styles/global';
import AppProvider from './hooks';
import { NotificationContainer } from 'react-notifications';

const App = () => {
  return (
    <>
      <AppProvider>
        <Routes />
      </AppProvider>
      <NotificationContainer />
      <GlobalStyle />
    </>
  );
};

export default App;
